import ApiCall from "../../utils/apiCall";

export const getChurnProducts = () => {
  return ApiCall.get("/churn_products");
};



// WEBPACK FOOTER //
// ./src/newDropshipperApp/module/churnProducts.js